import React, { useEffect, useRef, useState } from 'react';
import API_BASE_URL from "../../../apiConfig";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const AddressUpdateCompleteReport = () => {
    const [addressData, setAddressData] = useState([]);
    const tableRef = useRef(null);

    // 🔹 Fetch Address Update Records
    useEffect(() => {
        const fetchAddressData = async () => {
            try {
                const authToken = localStorage.getItem("authToken");

                const response = await fetch(`${API_BASE_URL}/AddressUpdate/GetAddressUpdateRecords`,
                    {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${authToken}`,
                        }
                    }
                );

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                let data = await response.json();

                // 🔹 Filter for Complete, Rejected, and Refunded statuses
                const filteredData = data.filter(r => r.status === "Complete" || r.status === "Rejected" || r.status === "Refunded");

                // 🔹 Add SrNo
                const mappedData = filteredData.map((record, index) => ({
                    ...record,
                    SrNo: index + 1
                }));

                setAddressData(mappedData);
            } catch (error) {
                console.error('Failed to fetch address update records:', error);
            }
        };

        fetchAddressData();
    }, []);


    // 🔹 Init DataTable
    useEffect(() => {
        if (tableRef.current && addressData.length > 0) {
            const table = $(tableRef.current).DataTable({
                destroy: true,
                data: addressData,
                columns: [
                    { data: 'SrNo', title: 'Sr No' },
                    { data: 'startDate', title: 'Date' },
                    { data: 'registrationNo', title: 'Registration No' },
                    { data: 'registerMobNo', title: 'Mobile No' },
                    { data: 'aadhaarNumber', title: 'Aadhaar No' },
                    { data: 'address', title: 'Address' },
                    { data: 'pinCode', title: 'Pin Code' },
                    { data: 'state', title: 'State' },
                    { data: 'district', title: 'District' },
                    { data: 'postOffice', title: 'Post Office' },
                    {
                        data: 'status',
                        title: 'Status',
                        render: function (data) {
                            const getStatusColor = (status) => {
                                switch (status) {
                                    case 'In Progress': return '#17a2b8';
                                    case 'Complete': return '#28a745';
                                    case 'Rejected': return '#dc3545';
                                    case 'Refunded': return '#ffc107';
                                    default: return '#6c757d';
                                }
                            };

                            return `<span class="badge" style="background-color: ${getStatusColor(data)}; color: #fff; padding: 5px 10px; border-radius: 4px; font-weight: bold;">${data}</span>`;
                        }
                    },
                    { data: 'comment', title: 'Comment' },
                    {
                        data: null,
                        title: "Document",
                        render: function (data, type, row) {
                            return `<button class="btn btn-sm btn-success download-doc-btn" data-id="${row.registrationNo}">Download</button>`;
                        }
                    }
                ]
            });

            // Document download handler
            $('#productsTable tbody')
                .off('click', '.download-doc-btn')
                .on('click', '.download-doc-btn', function () {
                    const registrationNo = $(this).data("id");
                    downloadDocument(registrationNo);
                });

            return () => {
                table.destroy();
            };
        }
    }, [addressData]);

    // 🔹 Download uploaded document
    const downloadDocument = async (registrationNo) => {
        try {
            const authToken = localStorage.getItem("authToken");

            const response = await fetch(`${API_BASE_URL}/AddressUpdate/DownloadDocument/${registrationNo}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Failed to download document");
            }

            const blob = await response.blob();
            const contentType = response.headers.get("Content-Type");
            const extension = contentType?.split("/")[1] || "file";

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `AddressUpdate_${registrationNo}.${extension}`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } catch (error) {
            console.error("Download error:", error);
        }
    };

    return (
        <table
            ref={tableRef}
            id="productsTable"
            className="table table-bordered table-hover table-product"
            style={{ width: '100%' }}
        >
            <thead>
                <tr>
                    <th>Sr. No.</th>
                    <th>Date</th>
                    <th>Registration No</th>
                    <th>Mobile No</th>
                    <th>Aadhaar No</th>
                    <th>Address</th>
                    <th>Pin Code</th>
                    <th>State</th>
                    <th>District</th>
                    <th>Post Office</th>
                    <th>Status</th>
                    <th>Comment</th>
                    <th>Document</th>
                </tr>
            </thead>
        </table>
    );
};

export default AddressUpdateCompleteReport;
